/*!

=========================================================
* Vision UI Free React - v1.0.0
=========================================================

* Product Page: https://www.creative-tim.com/product/vision-ui-free-react
* Copyright 2021 Creative Tim (https://www.creative-tim.com/)
* Licensed under MIT (https://github.com/creativetimofficial/vision-ui-free-react/blob/master LICENSE.md)

* Design and Coded by Simmmple & Creative Tim

=========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

*/

/** 
  All of the routes for the Vision UI Dashboard React are added here,
  You can add a new route, customize the routes and delete the routes here.

  Once you add a new route on this file it will be visible automatically on
  the Sidenav.

  For adding a new route you can follow the existing routes in the routes array.
  1. The `type` key with the `collapse` value is used for a route.
  2. The `type` key with the `title` value is used for a title inside the Sidenav. 
  3. The `type` key with the `divider` value is used for a divider between Sidenav items.
  4. The `name` key is used for the name of the route on the Sidenav.
  5. The `key` key is used for the key of the route (It will help you with the key prop inside a loop).
  6. The `icon` key is used for the icon of the route on the Sidenav, you have to add a node.
  7. The `collapse` key is used for making a collapsible item on the Sidenav that has other routes
  inside (nested routes), you need to pass the nested routes inside an array as a value for the `collapse` key.
  8. The `route` key is used to store the route location which is used for the react router.
  9. The `href` key is used to store the external links location.
  10. The `title` key is only for the item with the type of `title` and its used for the title text on the Sidenav.
  10. The `component` key is used to store the component of its route.
*/

// Vision UI Dashboard React layouts
import Dashboard from "layouts/dashboard";
import Alliance from "layouts/alliance";
import Guild from "layouts/guild";
import GuildsEdit from "layouts/guildsedit";
import Member from "layouts/member";
import Members from "layouts/members";
import MembersEdit from "layouts/membersedit";
import Compare from "layouts/compare";
import SignIn from "layouts/authentication/sign-in";
import SignOut from "layouts/authentication/sign-out";

// Vision UI Dashboard React icons
import { BiExit } from "react-icons/bi";
import { IoRocketSharp } from "react-icons/io5";
import { IoHome } from "react-icons/io5"; // home
import { AiFillBank } from "react-icons/ai"; // home
import { FaUsers } from "react-icons/fa"; // users
import { MdOutlineCompareArrows } from "react-icons/md"; // compare

const routes = [
    {
        type: "collapse",
        name: "Dashboard",
        key: "dashboard",
        route: "/dashboard",
        icon: <IoHome size="15px" color="inherit" />,
        component: Dashboard,
        noCollapse: true,
    },
    {
        type: "collapse",
        name: "Alliance",
        key: "alliance",
        route: "/alliance",
        icon: <AiFillBank size="15px" color="inherit" />,
        component: Alliance,
        noCollapse: true,
    },
    {
        type: "none",
        name: "Guild",
        key: "guild",
        route: "/guild",
        icon: <AiFillBank size="15px" color="inherit" />,
        component: Guild,
        noCollapse: true,
    },
    {
        type: "none",
        name: "GuildsEdit",
        key: "guildsedit",
        route: "/guildsedit",
        icon: <AiFillBank size="15px" color="inherit" />,
        component: GuildsEdit,
        noCollapse: true,
    },
    {
        type: "none",
        name: "Member",
        key: "member",
        route: "/member",
        icon: <AiFillBank size="15px" color="inherit" />,
        component: Member,
        noCollapse: true,
    },
    {
        type: "none",
        name: "MembersEdit",
        key: "membersedit",
        route: "/membersedit",
        icon: <AiFillBank size="15px" color="inherit" />,
        component: MembersEdit,
        noCollapse: true,
    },
    {
        type: "collapse",
        name: "Members",
        key: "members",
        route: "/members",
        icon: <FaUsers size="15px" color="inherit" />,
        component: Members,
        noCollapse: true,
    },
    {
        type: "collapse",
        name: "Compare",
        key: "compare",
        route: "/compare",
        icon: <MdOutlineCompareArrows size="15px" color="inherit" />,
        component: Compare,
        noCollapse: true,
    },
    { type: "title", title: "Account Pages", key: "account-pages" },
    {
        type: "none",
        name: "Sign In",
        key: "sign-in",
        route: "/authentication/sign-in",
        icon: <IoRocketSharp size="15px" color="inherit" />,
        component: SignIn,
        noCollapse: true,
    },
    {
        type: "collapse",
        name: "Sign Out",
        key: "sign-out",
        route: "/authentication/sign-out",
        icon: <BiExit size="15px" color="inherit" />,
        component: SignOut,
        noCollapse: true,
    },
];

export default routes;
